
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Check'
})
export default class Check extends Vue {}
